/** Reyting (demo v3 `Rank`): barcha Lexo o'quvchilari — shu hafta (dushanbadan) yoki umumiy XP. lexo-api `/v1/leaderboard?scope=week|total`. Stek ekrani. */
import { useEffect, useState } from 'react';
import { useStore } from '../store';
import { nav } from '../lib/nav';
import { sync, type ApiPlayer } from '../lib/sync';
import { t, tn } from '../i18n';
import { Ic } from '../ui/Icon';
import { MyAvatar, PlayerAvatar } from '../ui/Avatar';

export type RankScope = 'week' | 'total';
export type RankRow = ApiPlayer & { me: boolean };

/** Serverdan kelgan ro'yxat; API bo'lmasa — faqat o'zim (joriy XP bilan). */
const cache: Partial<Record<RankScope, RankRow[]>> = {};
function fallback(): RankRow[] {
  const s = useStore.getState();
  return [{ id: 0, n: s.name || 'Siz', nick: s.nick, avatar: null, photo: false, frame: s.frame, xp: s.xp, me: true }];
}
export async function fetchRank(scope: RankScope): Promise<RankRow[]> {
  try {
    const r = await sync.leaderboard(scope);
    const list = r.list.map((x) => ({ ...x, me: !!x.me }));
    if (!list.some((x) => x.me)) list.push(fallback()[0]!);
    cache[scope] = list;
    return list;
  } catch {
    return cache[scope] ?? fallback();
  }
}
export function myRank(scope: RankScope) {
  const l = cache[scope] ?? fallback(); const i = Math.max(0, l.findIndex((x) => x.me));
  return { me: i + 1, list: l, next: i > 0 ? l[i - 1]! : null };
}

const label = (x: RankRow) => (x.nick ? '@' + x.nick : x.n);
function Av({ x, sz }: { x: RankRow; sz: number }) { return x.me ? <MyAvatar size={sz} /> : <PlayerAvatar p={x} size={sz} />; }

const SCOPES: Array<[RankScope, string]> = [['week', 'Shu hafta'], ['total', 'Umumiy']];

export function Rank() {
  const [rs, setRs] = useState<RankScope>('week');
  const [list, setList] = useState<RankRow[]>(() => myRank('week').list);
  useEffect(() => { let on = true; fetchRank(rs).then((l) => { if (on) setList(l); }); return () => { on = false; }; }, [rs]);

  const i = Math.max(0, list.findIndex((x) => x.me));
  const me = i + 1, next = i > 0 ? list[i - 1]! : null, xp = list[i]?.xp ?? 0;
  const need = next ? next.xp - xp + 1 : 0;
  const prog = next && next.xp > 0 ? Math.max(6, Math.min(100, Math.round(xp / next.xp * 100))) : 100;
  const top = list.slice(0, 3), rest = list.slice(3);
  const fmt = (n: number) => n.toLocaleString('ru');

  return (
    <main className="content fade">
      <div className="row g10">
        <button className="sq2 card" aria-label={t('Orqaga')} onClick={() => nav.pop()}><Ic n="back" size={20} /></button>
        <b className="grow" style={{ fontSize: 20, fontWeight: 800 }}>{t('Reyting')}</b>
        <span className="soon" style={{ background: 'var(--primary-soft)', color: 'var(--primary-ink)' }}>{t('Barcha oʻquvchilar')}</span>
      </div>
      <section className="me2">
        <div className="row g12">
          <MyAvatar size={52} />
          <div className="grow col"><span style={{ opacity: .7, fontSize: 12, fontWeight: 700 }}>{t('SIZNING OʻRNINGIZ')}</span><b style={{ fontSize: 26 }}>{tn('#-oʻrin', me)}</b></div>
          {next
            ? <span className="soon" style={{ background: 'rgba(255,255,255,.14)', color: '#fff' }}><Ic n="up" size={14} /> {tn('keyingi: #', me - 1)}</span>
            : <span className="soon" style={{ background: 'var(--peach)', color: 'var(--on-peach)' }}>{t('Yetakchi!')}</span>}
        </div>
        <div className="bar2"><i style={{ width: `${prog}%` }} /></div>
        <span style={{ fontSize: 13, opacity: .85, fontWeight: 600 }}>
          {next ? <>{tn('#-oʻringa chiqish uchun yana', me - 1)} <b style={{ color: '#FFC629' }}>{tn('# XP', need)}</b></> : t('Siz birinchi oʻrindasiz — oʻrningizni saqlang!')}
        </span>
      </section>
      <div className="seg2">
        {SCOPES.map(([k, l]) => <button key={k} className={rs === k ? 'on' : ''} onClick={() => setRs(k)}>{t(l)}</button>)}
      </div>
      <div className="podium rk">
        {[1, 0, 2].map((j) => {
          const x = top[j];
          if (!x) return <div key={j} className="pc" />;
          const pl = j + 1;
          return (
            <div key={j} className={`pc p${pl} ${x.me ? 'me' : ''}`}>
              {pl === 1 && <span className="crown"><Ic n="crown" size={22} /></span>}
              <Av x={x} sz={pl === 1 ? 60 : 50} />
              <b style={{ textAlign: 'center' }}>{label(x)}</b>
              <span>{tn('# XP', fmt(x.xp))}</span>
              <div className="step">{pl}</div>
            </div>
          );
        })}
      </div>
      <div className="col g8">
        {rest.map((x, k) => (
          <div key={x.id + ':' + k} className={`li2 ${x.me ? 'me' : ''}`}>
            <span className="n">{k + 4}</span>
            <Av x={x} sz={38} />
            <b className="grow">{label(x)}{x.me ? ` (${t('siz')})` : ''}</b>
            <span style={{ fontWeight: 800, fontSize: 14, color: x.me ? 'var(--primary-ink)' : 'var(--muted)' }}>{fmt(x.xp)}</span>
          </div>
        ))}
      </div>
      <p className="t12" style={{ margin: 0 }}>{t('Reyting barcha Lexo oʻquvchilari orasida. Haftalik reyting har dushanba yangilanadi.')}</p>
    </main>
  );
}
